import { render, staticRenderFns } from "./separateHistory.vue?vue&type=template&id=e07d614e&scoped=true&"
import script from "./separateHistory.vue?vue&type=script&lang=js&"
export * from "./separateHistory.vue?vue&type=script&lang=js&"
import style0 from "./separateHistory.vue?vue&type=style&index=0&id=e07d614e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07d614e",
  null
  
)

export default component.exports